import React, { useContext } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Global, {  isValidAccount, saveReadedAd, saveUnreadedAds } from "../../util/Global";
import moment from 'moment';
import { useTranslation } from "react-i18next";
import { DashboardHeaderContext } from "../../components/DashboardHeader";
import { AlertContext } from "../../util/Alerter";
import { LoaderComponent } from "../../util/Loader";
import NotFound from "../../components/NotFound";
import { Chip } from "@mui/material";
import { getUserFullName } from "../../components/Utils";


const MyDetailsAnnonce = ({ isAdmin }) => {

  const { t } = useTranslation();

  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setisLoading] = useState(true);
  const [adsDetails, setadsDetails] = useState("");
  const [selectedImg, setselectedImg] = useState(0);

  const { showAlert } = useContext(AlertContext)
  const { countUnreadedAds, setcountUnreadedAds, setnavLinks, setpageTitle, setpageNavLink, setalertTitle } = useContext(DashboardHeaderContext)


  const ADS_DETAILS_URL = Global.backend + "/index.php/showAnnonce";
  const ADS_DELETE_URL = Global.backend + "/index.php/deleteAnnonce";


  useEffect(() => {
    if (isAdmin) {
      setpageNavLink({ path: "/dashboard/admin", label: "adminDashboard" })
      setnavLinks([{ path: "/dashboard/admin/annonces-admin", label: "adsList" }])
    } else {
      setpageNavLink({ path: "/dashboard/user/ajouterannonce", label: "filterannonce2.1" })
      setnavLinks([{ path: "/dashboard/user/mesannonces", label: "profileentreprise18.1" }])
      setalertTitle(!isValidAccount() && "invisibleAds")
    }

    setpageTitle("adsDetails")
  }, [])



  useEffect(() => {
    setisLoading(true)

    axios.all([
      axios.post(ADS_DETAILS_URL, { userId: localStorage.getItem("id"), annonceId: id })
    ]).then(axios.spread((adsResponse) => {
      if (!adsResponse.data) {
        return
      }
      // mark as read
      if (saveReadedAd(id)) {
        setcountUnreadedAds(countUnreadedAds - 1)
        saveUnreadedAds(countUnreadedAds - 1)
      }

      setadsDetails(adsResponse.data);
    }))
      .catch((err) => {
        showAlert("error", t("request.errorFetchingAdsDetails"))
      })
      .finally(() => {
        setisLoading(false);
      });
  }, []);



  const AlertSupp = (pId) => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success ml-3",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: t("alertTitle.confirm"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: t("alertButton.delete"),
        cancelButtonText: t("alertButton.cancel"),
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          setisLoading(true)
          axios.post(ADS_DELETE_URL, { userId: localStorage.getItem("id"), annonceId: id }).then(() => {
          }).catch((err) => {
            showAlert("error", t("request.errorDeleteAd"))
          }).finally(() => {
            setisLoading(false)
            showAlert("success", t("request.successDeleteAd"))

            if (isAdmin) {
              navigate("/dashboard/admin/annonces-admin")
            } else {
              navigate("/dashboard/user/mesannonces")
            }

          })
        }
      });
  };




  return (
    <LoaderComponent isLoading={isLoading}>
      {!isLoading &&
        (!adsDetails ? <NotFound /> :
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-5">
                        <div className="product-detail">
                          <div className="row">
                            <div className="col-3">





                            </div>
                            <div className="col-md-8 col-9">
                              <div
                                className="tab-content"
                                id="v-pills-tabContent"
                              >
                                <div
                                  className="tab-pane fade show active"
                                  role="tabpanel"
                                >
                                  <div
                                    style={{
                                      borderRadius: 10,
                                      overflow: "hidden",
                                      border: "1px solid #ccc",
                                      height: 250,
                                    }}
                                  >
                                    <img
                                      src={adsDetails.image ? `${Global.backend}/uploads/${adsDetails.image}` : require("../../assets/img/default_product.png")}
                                      alt=""
                                      className="img-fluid mx-auto d-block"
                                      data-zoom={require("../../assets/BackOffice/images/product/img-1.png")}
                                      style={{ height: 250 }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-7">
                        <div className="mt-4 mt-xl-3">

                          <div className="d-flex align-items-center">
                            <h4 className="text-primary m-0">
                              {adsDetails.titre}
                            </h4>
                            <Chip className="ms-2" label={t(adsDetails.etat ? (adsDetails.etat == -1 ? "ads.rejected" : "ads.approved") : "ads.waiting")} color={adsDetails.etat ? (adsDetails.etat == -1 ? "error" : "success") : "info"} />
                          </div>





                          <div className="mt-4">
                            <h6>{t("ads.description")} :</h6>

                            <div className="mt-4">
                              <p className="text-muted mb-2">
                                <i className="mdi mdi-check-bold text-success me-2"></i>
                                {adsDetails.description}
                              </p>
                            </div>
                          </div>






                          <div className="mt-4">
                            <button
                              type="button"
                              className="btn waves-effect waves-light m-2"
                              onClick={() => {
                                if (isAdmin) {
                                  navigate("/dashboard/admin/modifierannonce/" + id);
                                } else {
                                  navigate("/dashboard/user/modifierannonce/" + id);
                                }
                              }}
                              style={{
                                backgroundColor: "orange",
                                color: "white",
                              }}
                            >
                              <i className="mdi mdi-delete me-2"></i>{" "}
                              {t("editAd")}
                            </button>
                            <button
                              type="button"
                              className="btn btn-danger waves-effect waves-light m-2"
                              onClick={() => AlertSupp()}
                            >
                              <i className="mdi mdi-delete me-2"></i>{" "}
                              {t("deleteAd")}
                            </button>
                          </div>


                        </div>
                      </div>
                    </div>




                    <div className="container-fluid">
                      <div className="row mt-3">
                        <div className="col-lg-12">
                          <div className="card">
                            <div className="card-body">
                              <div className="table-responsive">
                                <table
                                  className="table table-centered dt-responsive nowrap"
                                  style={{
                                    borderCollapse: "collapse",
                                    borderSpacing: "0",
                                    width: "100%",
                                  }}
                                >
                                  <thead className="thead-light">
                                    <tr>
                                      <th>{t("ads.publisherName")}</th>
                                      <th>{t("ads.category")}</th>
                                      <th>{t("ads.country")}</th>
                                      <th>{t("detailproduit17.1")}</th>
                                      <th>{t("detailproduit18.1")}</th>
                                      <th>{t("detailproduit19.1")}</th>
                                      <th>{t("ads.publishDate")}</th>
                                      <th>{t("ads.views")}</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>{getUserFullName(t,adsDetails.user)}</td>
                                      <td>{t("ads.categories." + adsDetails.categorie)}</td>
                                      <td>{adsDetails.user.pays}</td>
                                      <td>{t("user.services." + adsDetails.user.service)} {"/"} {t("user.functions." + adsDetails.user.fonction)}</td>
                                      <td>{adsDetails.user.telephone}</td>
                                      <td>{adsDetails.user.phone}</td>
                                      <td>{adsDetails.date + " (" + moment(adsDetails.date).fromNow() + ")"}</td>
                                      <td>{adsDetails.vu || 0}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                  </div>
                </div>


              </div>
            </div>
          </div>)
      }
    </LoaderComponent>
  );
};

export default MyDetailsAnnonce;
